import { useState, useEffect } from "react"
import axios from "axios"

const Inventory = () => {
  const [searchTerm, setSearchTerm] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [inventory, setInventory] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchInventory()
    // eslint-disable-next-line
  }, [])

  const fetchInventory = async () => {
    try {
      setIsLoading(true)
      setError(null)
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-inventory`,
        {
          headers: {
            'authorization':  localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.inventory) {
        setInventory(response.data.inventory)
      } else if (Array.isArray(response.data)) {
        setInventory(response.data)
      } else {
        setInventory([])
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch inventory")
    } finally {
      setIsLoading(false)
    }
  }

  const filteredInventory = inventory.filter(
    (item) =>
      (item.product_name && item.product_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.product_master_code && item.product_master_code.toLowerCase().includes(searchTerm.toLowerCase()))
  )

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage
  const indexOfFirstRow = indexOfLastRow - rowsPerPage
  const currentRows = filteredInventory.slice(indexOfFirstRow, indexOfLastRow)
  const totalPages = Math.ceil(filteredInventory.length / rowsPerPage)

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-full mx-auto">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h1 className="text-2xl font-semibold text-gray-900 mb-6">Inventory</h1>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
            <input
              type="text"
              placeholder="Search by product name or code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-72 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
            />
            <select
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
              className="w-full md:w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
            >
              {[10, 20, 50, 100].map((num) => (
                <option key={num} value={num}>{num} / page</option>
              ))}
            </select>
          </div>
          {isLoading ? (
            <div className="text-center py-10 text-gray-500">Loading inventory...</div>
          ) : error ? (
            <div className="text-center py-10 text-red-500">{error}</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-[1800px] divide-y divide-gray-200 text-xs md:text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-2 py-2 min-w-[60px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">#</th>
                    <th className="px-2 py-2 min-w-[130px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material Code</th>
                    <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material Name</th>
                    <th className="px-2 py-2 min-w-[120px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Category</th>
                    <th className="px-2 py-2 min-w-[90px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Unit</th>
                    <th className="px-2 py-2 min-w-[100px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Color</th>
                    <th className="px-2 py-2 min-w-[150px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Material Master Code</th>
                    <th className="px-2 py-2 min-w-[110px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity IN</th>
                    <th className="px-2 py-2 min-w-[90px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity OUT</th>
                    <th className="px-2 py-2 min-w-[120px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity Balance</th>
                    <th className="px-2 py-2 min-w-[100px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Rejected Quantity</th>
                    <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Avg Purchase Price (INR) </th> 
                {/* <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Selling Price/Unit</th> */}
                {/* <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Total Purchase Price</th> */}
                {/*  <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Total Selling Price</th>  */}                    
                {/*  <th className="px-2 py-2 min-w-[140px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Quantity Remaining</th> */} 
                    <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Stock Value (INR)</th> 
                {/*  <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Purchase Qty Freeze</th> */} 
                {/* <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Purchase Freeze Status</th> */} 
                {/*  <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Purchase Stock Out</th> */} 
                 {/*   <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Selling Qty Freeze</th> */} 
                    <th className="px-2 py-2 min-w-[140px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Added By</th>
                {/*   <th className="px-2 py-2 min-w-[160px] whitespace-nowrap text-left font-medium text-gray-500 uppercase tracking-wider">Created At</th> */}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {currentRows.length === 0 ? (
                    <tr>
                      <td colSpan={23} className="text-center py-8 text-gray-400">No inventory found.</td>
                    </tr>
                  ) : (
                    currentRows.map((item, idx) => (
                      <tr key={item.id || idx}>
                        <td className="px-2 py-2 whitespace-nowrap">{indexOfFirstRow + idx + 1}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.product_master_code}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.product_name}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.category_name}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.product_unit}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.product_color}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.product_unique_code}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.quantity_purchased}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.quantity_sold}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.quantity_inventory}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.quantity_rejected ?? '-'}</td>
                        <td className="px-2 py-2 whitespace-nowrap">{item.purchase_price_per_unit ?? item.purchase_price_per_unit === 0 ? item.purchase_price_per_unit : '-'}</td>
                        {/* <td className="px-2 py-2 whitespace-nowrap">{item.selling_price_per_unit ?? item.selling_price_per_unit === 0 ? item.selling_price_per_unit : '-'}</td>  */}
                       {/*  <td className="px-2 py-2 whitespace-nowrap">{item.total_purchase_price ?? '-'}</td>  */}
                       {/*  <td className="px-2 py-2 whitespace-nowrap">{item.total_selling_price ?? '-'}</td>  */}
                        {/* <td className="px-2 py-2 whitespace-nowrap">{item.quantity_remaining ?? '-'}</td>  */}
                        <td className="px-2 py-2 whitespace-nowrap">{item.total_stock_price_left ?? '-'}</td>
                       {/*  <td className="px-2 py-2 whitespace-nowrap">{item.purchase_quantity_freeze ?? '-'}</td>  */}
                        {/* <td className="px-2 py-2 whitespace-nowrap">{item.purchase_quantity_freeze_status ?? '-'}</td>  */}
                       {/*  <td className="px-2 py-2 whitespace-nowrap">{item.purchase_quantity_stock_out ?? '-'}</td> */}
                      {/*   <td className="px-2 py-2 whitespace-nowrap">{item.selling_quantity_freeze ?? '-'}</td>  */}
                        <td className="px-2 py-2 whitespace-nowrap">{item.added_by}</td>
{/*                         <td className="px-2 py-2 whitespace-nowrap">{formatDate(item.created_at)}</td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
          {/* Pagination */}
          <div className="flex justify-between items-center mt-6">
            <div className="text-sm text-gray-600">
              Showing {filteredInventory.length === 0 ? 0 : indexOfFirstRow + 1} to {indexOfLastRow > filteredInventory.length ? filteredInventory.length : indexOfLastRow} of {filteredInventory.length} entries
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 disabled:opacity-50"
              >
                Prev
              </button>
              <span className="px-2 py-1 text-gray-700">Page {currentPage} of {totalPages || 1}</span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages || totalPages === 0}
                className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Inventory
